// extracted by mini-css-extract-plugin
export default {"wrapper":"WizardApprovalHistory_wrapper__17N8t"};